export default [
    '/login',
    '/forgot-password',
    '/reset-password'
]